module.exports = __webpack_public_path__ + "media/images/help/flow/bg-dotted-57e0b93416b7fb3b6b68f292e52d26e2.png";